import { render } from "./LoginCreate.vue?vue&type=template&id=7078f416"
import script from "./LoginCreate.vue?vue&type=script&lang=js"
export * from "./LoginCreate.vue?vue&type=script&lang=js"

import "./LoginCreate.vue?vue&type=style&index=0&id=7078f416&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__